module.exports = __webpack_public_path__ + "static/media/ET085 new.62508e65.jpg";